// extracted by mini-css-extract-plugin
module.exports = {"customizationLayout":"_1VZO4","blockTitle":"_18o9a","splitter":"_1qDVP","blockWrapper":"_1cT_U","colorPickerWrapper":"Df1gq","colorPicker":"Y4w4f","partnerSelection":"_3GYvu"};